// PdfDocument.js
import React from 'react';
import {Page, Text, View, Document, StyleSheet} from '@react-pdf/renderer';

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    padding: 10,
  },
  title: {
    fontSize: 16,
    marginBottom: 20,
    textAlign: 'center',
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginBottom: 20,
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableColHeader: {
    width: '33.33%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#34A56F',
    backgroundColor: '#34A56F',
    padding: 5,
    fontWeight: 'bold',
    fontSize: 14,
  },
  tableCol: {
    width: '33.33%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    padding: 5,
    fontSize: 10,
  },
});

// Create Document Component
const DownloadToPdf = ({data}) => (
  <Document>
    <Page size='A4' style={styles.page}>
      <Text style={styles.title}>Receipt generated successfully</Text>
      <View style={styles.table}>
        <View style={styles.tableRow}>
          <Text style={styles.tableColHeader}>Full Name</Text>
          <Text style={styles.tableColHeader}>Examination Number</Text>
          <Text style={styles.tableColHeader}>Pin</Text>
        </View>
        {data.map((row, index) => (
          <View style={styles.tableRow} key={index}>
            <Text style={styles.tableCol}>{row.fullName}</Text>
            <Text style={styles.tableCol}>{row.examinationNumber}</Text>
            <Text style={styles.tableCol}>{row.pin}</Text>
          </View>
        ))}
      </View>
    </Page>
  </Document>
);

export default DownloadToPdf;
